module.exports = __webpack_public_path__ + "static/media/trevo-lottie.73925080.gif";